import * as R from 'ramda';
import React, { Fragment, useCallback } from 'react';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// forms
import { Fieldset2 } from '../../forms';
// ui
import { Box, Flex, Form, ActionButton, RelativeFlex } from '../../ui';
// utilities
import routesMap from '../../utilities/routes';
// feature auth
import { LegalInfo } from './legal-info';
import {
  StyledLinkTo,
  StyledFormTitle,
  StyledFormSubtitle,
} from './ui';
//////////////////////////////////////////////////

const AllowedAuthClients = ({
  widthSubmitBtn,
  heightSubmitBtn,
  borderRadiusBtn,
  fontSizeSubmitBtn,
  allowedAuthClients,
}) => {
  const authWithMicrosoftAllowed = R.includes(GC.AUTH_CLIENT_MICROSOFT, allowedAuthClients);

  const onAzureSsoLogin = useCallback(() => G.goToRoute(routesMap.azureSsoRedirect), []);

  if (!authWithMicrosoftAllowed) return;

  return (
    <ActionButton
      mt={12}
      type='button'
      fontWeight='bold'
      width={widthSubmitBtn}
      onClick={onAzureSsoLogin}
      fontSize={fontSizeSubmitBtn}
      height={R.or(heightSubmitBtn, 42)}
      bgColor={G.getTheme('colors.azure')}
      textColor={G.getTheme('colors.white')}
      borderRadius={R.or(borderRadiusBtn, 4)}
    >
      {G.getWindowLocale('actions:sign-in-with-microsoft', 'Sign in with Microsoft')}
    </ActionButton>
  );
};

const AuthForm = ({
  props,
  title,
  fields,
  subtitle,
  mbLinkTo,
  widthLogo,
  widthForm,
  textAlign,
  heightLogo,
  pathLinkTo,
  actionLinkTo,
  isSubmitting,
  handleChange,
  handleSubmit,
  maxWidthForm,
  withLegalInfo,
  displayLinkTo,
  fontSizeTitle,
  widthSubmitBtn,
  actionSubmitBtn,
  heightSubmitBtn,
  displaySubtitle,
  borderRadiusBtn,
  puddingSubmitBtn,
  fontSizeSubmitBtn,
  displayInputsBlock,
  splashScreenSetting,
  alignSelfInputsBlock,
  justifySelfInputsBlock,
  justifyContentInputsBlock,
}) => {
  const allowedAuthClients = R.propOr([], GC.FIELD_BRANCH_ALLOWED_AUTH_CLIENTS, splashScreenSetting);

  const credentialsAllowed =
    R.isEmpty(allowedAuthClients) || R.includes(GC.AUTH_CLIENT_CREDENTIALS, allowedAuthClients);

  return (
    <Flex
      height='100%'
      padding='0 20px'
      flexDirection='column'
      justifyContent='center'
      width={R.or(widthForm, '37%')}
    >
      <Box mb={70} textAlign='left'>
        <img
          alt='Logo'
          width={widthLogo}
          height={heightLogo}
          src={R.or(R.path(['logoUrl'], splashScreenSetting), G.getNewLogoLink())}
        />
      </Box>
      <Form
        px={48}
        width='100%'
        p='25px 35px 35px'
        position='relative'
        borderRadius='16px'
        onSubmit={handleSubmit}
        padding='25px 35px 35px'
        maxWidth={R.or(maxWidthForm, 500)}
        boxShadow='0 2px 5px 0 rgba(0, 0, 0, 0.2)'
      >
        <StyledFormTitle textAlign={textAlign} fontSizeTitle={fontSizeTitle}>
          {title}
        </StyledFormTitle>
        <StyledFormSubtitle textAlign={textAlign} displaySubtitle={displaySubtitle}>
          {subtitle}
        </StyledFormSubtitle>
        {
          credentialsAllowed &&
          <Fragment>
            <RelativeFlex
              mt={47}
              display={displayInputsBlock}
              alignSelf={alignSelfInputsBlock}
              justifySelf={justifySelfInputsBlock}
              justifyContent={justifyContentInputsBlock}
            >
              <Fieldset2
                {...G.getFormikProps(props)}
                fields={fields}
                flexDirection='column'
                justifyContent='center'
                fieldsGroupMargin='0px'
                handleChange={handleChange}
              />
              <Flex
                mb={mbLinkTo}
                alignItems='center'
                display={displayLinkTo}
                justifyContent='flex-end'
              >
                <StyledLinkTo mt={12} fontSize={12} to={R.or(pathLinkTo, '')}>
                  {actionLinkTo}
                </StyledLinkTo>
              </Flex>
            </RelativeFlex>
            <ActionButton
              type='submit'
              fontWeight='bold'
              p={puddingSubmitBtn}
              width={widthSubmitBtn}
              disabled={isSubmitting}
              fontSize={fontSizeSubmitBtn}
              height={R.or(heightSubmitBtn, 42)}
              textColor={G.getTheme('colors.black')}
              borderRadius={R.or(borderRadiusBtn, 4)}
              bgColor={R.pathOr(G.getTheme('colors.lime'), ['buttonBackgroundColor'], splashScreenSetting)}
            >
              {actionSubmitBtn}
            </ActionButton>
          </Fragment>
        }
        <AllowedAuthClients
          widthSubmitBtn={widthSubmitBtn}
          heightSubmitBtn={heightSubmitBtn}
          borderRadiusBtn={borderRadiusBtn}
          fontSizeSubmitBtn={fontSizeSubmitBtn}
          allowedAuthClients={allowedAuthClients}
        />
      </Form>
      {G.isTrue(withLegalInfo) && <LegalInfo />}
    </Flex>
  );
};

export default AuthForm;
